import { connect } from 'react-redux';
import { getSubCategories } from 'common/ducks/categories';
import HeroSubcatSelect from 'marketing/components/hero_subcat_select';

const mapStateToProps = ({ categories }) => {
  return {
    subCategories: getSubCategories(categories)
  };
}

export default connect(mapStateToProps)(HeroSubcatSelect);
